var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.Item)?_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('p',[_vm._v(_vm._s(_vm.Item.Id))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }